<template lang="pug">

    div(style="")

        div(class="spark-item-label")
            div(class="last-sales-name") {{ label }}
            div(v-if="label !== 'S'" class="last-sales") {{ !isNaN(latestValue) && latestValue !== '' ? latestValue : '&nbsp;' }}
            div(v-else class="last-sales-s")
                div(class="" style="height:22px; line-height: 25px;") {{ !isNaN(latestValue) && latestValue !== '' ? latestValue : '&nbsp;' }}
                div(class="" style="font-size:10px; color:#817e7e") {{ formatSalesScale(getMapCompanies.get(company_id).last_sales) }}

        div(class="spark-item-sector")
            div()
                span(style="display:none") Sector 15
            div(class="spark-item-date")
                div() {{ latestYear }} -
                div() {{ latestQuarter }}


        div(class="spark-item-chart")
            v-sparkline(
                :class="getColor(color)"
                :value="companyReports"
                :labels="[' ', ' ', ' ', `${latestQuarter}`,' ', ' ', ' ', `${latestQuarter}`,' ', ' ', ' ', `${latestQuarter}`]"
                :label-size="22"
                :height="140"
                type="line"
                auto-line-width
                padding="3"
                style="width:100%"
            )

        //- remove when merge will success
        //- div(class="pl-2" style="height:40px; border:0px solid;")

            div(style="display: none;float:left; width:35%; font-size:22px; border:1px solid red") {{ label }}

            div(v-if="label !== 'S'" class="text-right" style="display: none;float:left; width:30%; font-size:22px; font-weight:600; border:1px solid green;") {{ !isNaN(latestValue) && latestValue !== '' ? latestValue : '&nbsp;' }}

            div(v-else class="text-center" style="display: none;float:left; height:40px; width:30%; border:3px solid orange;")
                div(class="text-right" style="display: none; height:25px; font-size:22px; font-weight:600; border:0px solid;") {{ !isNaN(latestValue) && latestValue !== '' ? latestValue : '&nbsp;' }}
                div(class="text-right" style="display: none;font-size:10px; color:#817e7e; border:0px solid;") {{ formatSalesScale(getMapCompanies.get(company_id).last_sales) }}

            div(class="text-right" style="float:left; width:35%; height:40px; color:#817e7e; padding-top:3px; border:1px solid orange;")
                div(class="pt-0 pb-0 pr-2 mt-0 mb-0" style="font-size:14px; height:18.8px; border:0px solid;") {{ latestQuarter }}
                div(class="pt-0 pb-0 pr-2 mt-0 mb-0" style="font-size:14px; height:18.8px; border:0px solid;") {{ latestYear }}

        //- div(class="pl-2" style="display:none;position:relative; font-size:16px; height:20px; border:2px solid;")
            div(:style="label !== 'S' ? 'bottom:15px;' : 'bottom:7px;'" style="position:-absolute; -height:20px; border:0px solid;") Sector
            div(:style="label !== 'S' ? 'bottom:15px;' : 'bottom:7px;'" class="text-right" style="position:-absolute; -left:70px; -height:20px; -width:30px; border:0px solid;") 15
        //- div(class="mt-1 pl-2 pr-2" style="border:0px solid;")
            v-sparkline(
                :class="getColor(color)"
                :value="companyReports"
                :labels="[' ', ' ', ' ', 'Q3',' ', ' ', ' ', 'Q3',' ', ' ', ' ', 'Q3']"
                :label-size="22"
                :height="150"
                type="line"
                auto-line-width
                padding="3"
                style="width:100%; border:1px solid;"
            )
</template>

<script>
import { mapGetters} from 'vuex';
import _ from 'lodash';

export default {
    name: 'SparkLine',
    props: {
        label: {
            type: String
        },
        color: {
            type: String,
            default: 'blue'
        },
        company_id: {
            type: Number
        }
    },
    data() {
        return {
            sparkLineColor: 'blue'
        };
    },
    // mounted() {
    //     console.log(this.getMapCompanies.get(this.company_id));
    //     console.log(this.companyReports);
    //     console.log(this.latestReport);
    //     console.log(this.latestQuarter);
    //     console.log(this.latestYear);
    //     console.log(this.salesDeltaPercentArray);
    //     console.log(this.profitMarginPercentArray);
    // },
    computed: {
        ...mapGetters([
            'getMapCompanies',
            'getAllStocks'
        ]),
        stock_id() {
            return parseInt(this.$route.params.stock_id);
        },
        companyReports() {
            let company = this.getMapCompanies.get(this.company_id);

            company.CompanyReports = company.CompanyReports.map((cr) => {
                cr.pe = cr.ttm_eps !== null ? (cr.price / cr.ttm_eps) : 0;
                cr.ps = cr.ttm_sps !== null ? (cr.price / cr.ttm_sps) : 0;

                return cr;
            });

            const companyReportsSortedOnPeriod = _.orderBy(company.CompanyReports, ['period'], ['asc']);

            let latestTwelveReports = [];

            if(this.label === 'EPS') {
                latestTwelveReports = companyReportsSortedOnPeriod.map((cr) => cr.eps).slice(-12);
            } else if(this.label === 'P/E') {
                latestTwelveReports = companyReportsSortedOnPeriod.map((cr) => cr.pe).slice(-12);
            } else if(this.label === 'S') {
                latestTwelveReports = companyReportsSortedOnPeriod.map((cr) => Math.round(cr.sales / 1000000)).slice(-12);
            } else if(this.label === 'P/S') {
                latestTwelveReports = companyReportsSortedOnPeriod.map((cr) => cr.ps).slice(-12);
            } else if(this.label === 'SΔ%') {
                latestTwelveReports = this.salesDeltaPercentArray;
            } else if(this.label === 'PM%') {
                latestTwelveReports = this.profitMarginPercentArray;
            }

            return latestTwelveReports;
        },
        latestReport() {
            const company = _.orderBy(this.getMapCompanies.get(this.company_id).CompanyReports, ['period'], ['desc']);

            const lastPostObject = company[0];

            return lastPostObject;
        },
        latestQuarter() {
            const quarter = this.latestReport.period.split('-')[1];

            return quarter;
        },
        latestYear() {
            const year = this.latestReport.period.split('-')[0];

            return year;
        },
        salesDeltaPercentArray() {
            const company = this.getMapCompanies.get(this.company_id);

            const companyReportsSortedOnPeriod = _.orderBy(company.CompanyReports, ['period'], ['asc']);

            const tempArray = companyReportsSortedOnPeriod.map((cr) => Math.round(cr.sales / 1000000)).slice(-12);
            const compareArray = companyReportsSortedOnPeriod.map((cr) => Math.round(cr.sales / 1000000)).slice(-13);

            const salesDeltaPercentArray = [];

            for(const [i, s] of tempArray.entries()) {
                const salesDeltaPercent = ((s - compareArray[i]) / compareArray[i]) * 100;

                salesDeltaPercentArray.push(salesDeltaPercent);
            }

            return salesDeltaPercentArray;
        },
        latestSalesDeltaPercent() {
            const salesDeltaPercent = this.salesDeltaPercentArray[this.salesDeltaPercentArray.length - 1];

            return salesDeltaPercent;
        },
        profitMarginPercentArray() {
            const company = this.getMapCompanies.get(this.company_id);

            const companyReportsSortedOnPeriod = _.orderBy(company.CompanyReports, ['period'], ['asc']);

            const tempArray = companyReportsSortedOnPeriod.slice(-12);

            const profitMarginPercentArray = [];

            for(const t of tempArray) {
                const profitMarginPercent = (Number(t.profit) / Number(t.sales)) * 100;

                profitMarginPercentArray.push(profitMarginPercent);
            }

            return profitMarginPercentArray;
        },
        latestProfitMarginPercent() {
            const profitMarginPercent = this.profitMarginPercentArray[this.profitMarginPercentArray.length - 1];

            return profitMarginPercent;
        },
        latestValue() {
            if(this.label === 'EPS') {
                try {
                    if(this.latestReport.eps !== NaN) {
                        return this.latestReport.eps.toFixed(1) !== '0.0' ? this.latestReport.eps.toFixed(1) : 0;
                    } else {
                        return '';
                    }
                } catch (error) {
                    return '';
                }
            } else if(this.label === 'P/E') {
                try {
                    return this.latestReport.pe.toFixed(1) !== '0.0' ? this.latestReport.pe.toFixed(1) : 0;
                } catch (error) {
                    return '';
                }
            } else if(this.label === 'S') {
                try {
                    return this.formatMillions(this.getMapCompanies.get(this.company_id).last_sales);
                } catch (error) {
                    return '';
                }
            } else if(this.label == 'P/S') {
                try {
                    return this.latestReport.ps.toFixed(1) !== '0.0' ? this.latestReport.ps.toFixed(1) : 0;
                } catch (error) {
                    return '';
                }
            } else if(this.label === 'SΔ%') {
                try {
                    return this.latestSalesDeltaPercent.toFixed(0);
                } catch (error) {
                    return '';
                }
            } else if(this.label === 'PM%') {
                try {
                    return this.latestProfitMarginPercent.toFixed(0);
                } catch (error) {
                    return '';
                }
            }
        }
    },
    methods: {
        getColor(color) {
            if(color === 'blue') {
                return 'blue-color';
            } else if(color === 'green') {
                return 'green-color';
            } else if(color === 'red') {
                return 'red-color';
            }
        },
        formatMillions(x) {
            let formatGrade = 1;

            if(this.formatSalesScale(x) === 'KSEK') {
                formatGrade = 1000;
            } else if(this.formatSalesScale(x) === 'MSEK') {
                formatGrade = 1000000;
            } else if(this.formatSalesScale(x) === 'MDRSEK') {
                formatGrade = 1000000000;
            }

            return (new Intl.NumberFormat('sv-SE').format((x/formatGrade).toFixed(0) ));
        },
        formatSalesScale(x) {
            const num = Number(x);

            let currencyFormat = '';

            if(num >= 0 && num <= 999) {
                currencyFormat = 'SEK';
            } else if(num >= 1000 && num <= 999999) {
                currencyFormat = 'KSEK';
            } else if(num >= 1000000 && num <= 999999999) {
                currencyFormat = 'MSEK';
            } else if(num >= 1000000000 && num <= 999999999999) {
                currencyFormat = 'MDRSEK';
            }

            return currencyFormat;
        }
    }
}
</script>

<style scoped>

.spark-item-label,
.spark-item-sector,
.spark-item-chart,
.spark-item-date {
    border: 0px solid blue;
    display: flex;
}

.spark-item-label {
    height: 38px
}

.spark-item-sector {
    align-items: center;
    justify-content: space-between;
    height: 24px;
}

.spark-item-date {
    color: rgba(129, 126, 126, 1);
    font-size: 14px;
}

/*temporary, before understanding logic */
.spark-item-sector > div:first-child {
    font-size: 16px;
}
/**/
[class^="last-sales"] {
    font-size: 24px;
}

.last-sales-name {
    font-weight: 300;
    padding-right: 12px;
}

.last-sales,
.last-sales-s {
    font-weight: 600;
}

.blue-color >>> g {
    fill: rgba(92,92,92,1);
    color: #817e7e;
}

.green-color >>> g {
    fill: green;
    color: #817e7e;
}

.red-color >>> g {
    fill: red;
    color: #817e7e;
}
</style>
